
export default {
    namespaced: true,
    state: {
        taskData: [],
        currentPage: 1,
        totalRows: null,
        perPage: 10,
    },
    getters: {
        TASK_DATA: state => {
            return state.taskData;
        },
        CURRENT_PAGE: state => {
            return state.currentPage;
        },
        TOTAL_ROWS: state => {
            return state.totalRows;
        },
        PER_PAGE: state => {
            return state.perPage;
        },
        AMOUNT_PAGE: (state) => {
            return Math.ceil(state.totalRows/state.perPage);
        }
    },
    mutations: {
        TASK_DATA: (state, payload) => {
            return state.taskData = payload;
        },
        CURRENT_PAGE: (state, payload) => {
            return state.currentPage = payload;
        },
        TOTAL_ROWS: (state, payload) => {
            return state.totalRows = payload;
        },
        PER_PAGE: (state, payload) => {
            return state.perPage = payload;
        },
    },
    actions: {
        GET_DATA: async ({state}, payload) => {
            payload.th.showOverlay ++;
            await payload.th.$store.dispatch('SEND_GET', {
                url: '/translation/tasks?perPage='+ state.perPage +'&currentPage='+ state.currentPage,
                th: payload.th,
                showSuccessMessage: false,
                getSuccessResponse: (responseData) => {
                    state.taskData = responseData.data;
                    state.totalRows = responseData.count;
                },
                getResponse: () => {
                    payload.th.showOverlay --;
                },
            });
        }
    }
}